import Joi from 'joi';
import PropTypes from 'prop-types';

import Conditional from '../../common/conditional';
import Button from '../../themed/button';
import Form from '../../common/form';

import { matchPhrases } from '../../../utils/utilities';
import { getAffirmativeOptions } from '../../../utils/data';

import toastService from '../../../services/toastService';
import withModules from '../../hoc/withModules';

class StructuralMemberForm extends Form {
	state: any = {
		data: {
			structureMemberName: '',
			hasAnomalies: '',
			inspectionDescription: 'No anomalies observed.',
			location: '',
		},
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
		structureMemberName: Joi.object({
				label: Joi.string().required(),
				value: Joi.string().required(),
				__isNew__: Joi.boolean().optional(),
			})
			.required()
			.label('Structural Member Name'),
		hasAnomalies: Joi.string().min(2).required().label('Has Anomalies'),
		inspectionDescription: Joi.string().when('hasAnomalies', {
			is: 'yes',
			then: Joi.string().allow('').optional().label('Inspection Description'),
			otherwise: Joi.string().min(3).required().label('Inspection Description'),
		}),
		location: Joi.string().allow('').optional().label('Location'),
	};

	static propTypes = {
		inspectableItems: PropTypes.array,
		onCancelEdit: PropTypes.func,
		structureDetails: PropTypes.object,
		enableComponentInspectionDetails: PropTypes.bool,
		onSave: PropTypes.func,
	};

	componentDidMount(): void {
		if (this.props.structureDetails) {
			const structureMemberName = this.createNewMultiSelectOption(this.props.structureDetails.structureMemberName);
			this.setState({ data: { ...this.props.structureDetails, structureMemberName } });
		}
	}

	createNewMultiSelectOption = (option: string) => {
		return { label: option, value: option };
	};

	handleNewOptionCreation = (option: string) => {
		const newOption = this.createNewMultiSelectOption(option);
		const data = { ...this.state.data, structureMemberName: newOption };

		this.setState({ data });
	};

	doSubmit = (): void => {
		this.props.onSave({
			structureMemberName: this.state.data.structureMemberName.value,
			hasAnomalies: this.state.data.hasAnomalies,
			inspectionDescription: this.state.data.inspectionDescription,
			location: this.state.data.location,
		});

		this.setState({
			data: {
				structureMemberName: '',
				hasAnomalies: '',
				inspectionDescription: 'No anomalies observed.',
				location: '',
			},
		});

		toastService.success('Structural Item Saved Successfully!');
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				<Conditional isVisible={!!this.props.enableComponentInspectionDetails}>
					{this.renderInput({
						type: 'text',
						name: 'location',
						placeholder: 'Enter Location e.g Section 1 (axes 1 to 7)',
						label: 'Location',
					})}

					<div className="my-4 divider"></div>
				</Conditional>

				<div className="row">
					<div className="col">
						{this.renderCreatableMultiselect({
							closeMenuOnSelect: true,
							options: this.props.inspectableItems,
							name: 'structureMemberName',
							placeholder: 'Enter Structural Member Name',
							label: 'Structural Member Name',
							isMulti: false,
							onCreateOption: this.handleNewOptionCreation
						})}
					</div>

					<div className="col">
						{this.renderSelect({
							name: 'hasAnomalies',
							placeholder: 'Does this structure have any anomalies?',
							label: 'Has Anomalies:',
							options: getAffirmativeOptions(),
						})}
					</div>
				</div>

				<div className="my-4 divider"></div>

				<Conditional isVisible={matchPhrases(this.state.data.hasAnomalies, 'no')}>
					{this.renderTextArea({
						name: 'inspectionDescription',
						placeholder: 'Enter Inspection Description',
						label: 'Inspection Description',
						rows: '6',
					})}

					<div className="my-4 divider"></div>
				</Conditional>

				<div className="d-flex justify-content-end">
					{this.renderButton('Save And Proceed')}

					<Conditional isVisible={!!this.props.onCancelEdit}>
						<div className="mx-4">
							<Button
								label="Cancel"
								style={{ backgroundColor: 'red' }}
								onClick={this.props.onCancelEdit}
							/>
						</div>
					</Conditional>
				</div>
			</form>
		);
	}
}

export default withModules(StructuralMemberForm);
